<script setup lang="ts">
/**
 * 全局统一弹框 —— 替代原生 confirm/alert，对齐 App 端弹框样式。
 * 只需在 App.vue 挂一个实例，业务侧用 @/utils/dialog 的 showConfirm / showAlert 命令式调用。
 */
import { dialogState, _confirmDialog, _cancelDialog } from '@/utils/dialog'

// 点遮罩：等同取消（alert 无取消语义时也按关闭处理）
function onMaskClick() {
  _cancelDialog()
}
</script>

<template>
  <Teleport to="body">
    <Transition name="app-dialog-fade">
      <div v-if="dialogState.visible" class="app-dialog-mask" @click="onMaskClick">
        <div class="app-dialog" @click.stop>
          <div v-if="dialogState.title" class="app-dialog__title">{{ dialogState.title }}</div>
          <div class="app-dialog__message">{{ dialogState.message }}</div>
          <div class="app-dialog__actions">
            <button
              v-if="dialogState.showCancel"
              type="button"
              class="app-dialog__btn app-dialog__btn--cancel"
              @click="_cancelDialog"
            >
              {{ dialogState.cancelText }}
            </button>
            <button
              type="button"
              class="app-dialog__btn app-dialog__btn--confirm"
              @click="_confirmDialog"
            >
              {{ dialogState.confirmText }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style lang="scss" scoped>
.app-dialog-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
}
.app-dialog {
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: 16px;
  padding: 24px 20px 16px;
  text-align: center;
}
.app-dialog__title {
  font-size: 17px;
  font-weight: 600;
  color: #100d27;
  margin-bottom: 12px;
}
.app-dialog__message {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  white-space: pre-wrap;
  word-break: break-word;
}
.app-dialog__actions {
  display: flex;
  gap: 12px;
}
.app-dialog__btn {
  flex: 1;
  padding: 11px 0;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  -webkit-tap-highlight-color: transparent;
}
.app-dialog__btn--cancel {
  border: 1px solid #333;
  background: transparent;
  color: #333;
}
.app-dialog__btn--confirm {
  border: none;
  background: #100d27;
  color: #fff;
}

/* 淡入 + 轻微缩放 */
.app-dialog-fade-enter-active,
.app-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
  .app-dialog {
    transition: transform 0.2s ease;
  }
}
.app-dialog-fade-enter-from,
.app-dialog-fade-leave-to {
  opacity: 0;
  .app-dialog {
    transform: scale(0.92);
  }
}
</style>
